module.exports = __webpack_public_path__ + "90ea4ef0870079c8a9fc33aeb5bb0f02.svg";